<div style="width: 100%; margin: 0 auto;" class="d-flex">
  <div class="container">
    <div class="wrapper display-layout" style="width: 40%; height:80%; border-radius: 0px">
      <div class="logo">
        <img alt="Sokrates Admin" class="d-inline-block me-3" src="https://files.sokrates.co.id/pri/image/tenant/logo/9b00f263-7bae-4643-ac77-9bff22183e0d.png">
        <img alt="Sokrates Admin" class="d-inline-block" src="assets/images/excul5.jpg">
        <!-- <span class="logo mb-3 d-flex justify-content-center"> -->
        <!-- </span> -->
      </div>
    </div>
    <div class="wrapper p-3" style="border-radius: 0px; height: 80%">
      <!-- <div class="logo logo-tenant">
        <img alt="{{ schoolName }}" class="d-inline-block" src="{{ logo }}">
      </div> -->
      <article>
        <!--        <span class="title mb-2">Welcome</span>-->
          <div class="logo mb-3 flex-column justify-content-center align-items-center display-logo">
              <img alt="Sokrates Admin" class="display-logo"
               src="https://files.sokrates.co.id/pri/image/tenant/logo/9b00f263-7bae-4643-ac77-9bff22183e0d.png">
          </div>
        <div class="pt-2">
          <!-- Signing in through SSO (Enforce SSO, or opened from another app): on the way to SSO. -->
          <div *ngIf="loading && !errorMsg" class="text-center">
            <i class="fa fa-spin fa-spinner fa-2x"></i>
            <p class="mt-2 text-muted">Menghubungkan ke SSO...</p>
          </div>
          <div *ngIf="errorMsg" class="text-center">
            <div class="d-flex flex-column">
              <h4 class="text-danger font-weight-bold m-1">{{ errorMsg }}</h4>
              <a (click)="retry()" class="text-primary small" style="cursor: pointer;">Coba Lagi</a>
            </div>
          </div>
          <!-- SSO not enforced: the legacy login form. -->
          <div *ngIf="showLoginForm && !errorMsg" class="text-center">
            <app-login></app-login>
          </div>
        </div>

        <div class=" logo pt-1 text-muted text-center border-top-0">
          <small>Powered by <b><a style="text-decoration:none;" href="https://sokrates.id" target="_blank">Sokrates</a></b></small>
          <br>
          <small>
<!--            <a href="https://changelog.sokrates.co.id" target="_blank">v{{ currentApplicationVersion }}</a>-->
          </small>
        </div>
      </article>

    </div>
  </div>
</div>
